import { ORDER_DELIVERY_STATUS } from 'src/constants/Constants'

export const PACKAGE_TRANSFER = {
  order_package_id: '',
  internal_order: '',
  cage_name: '',
  door_name: '',
}

export const INITIAL_SHIPPING_SEARCH_PARAMS = {
  id: '',
  client_id: '',
  order_number: '',
  internal_order: '',
  carrier: '',
  delivery_status: '',
  date_field: '',
  start_date: '',
  end_date: '',
  sort_method: 'desc',
  order_by: 'id',
  limit: 15,
  page: 1,
}

// a single package's statuses; the others are order rollups
export const PACKAGE_DELIVERY_STATUSES = [
  ORDER_DELIVERY_STATUS.TRACKING_ADDED,
  ORDER_DELIVERY_STATUS.IN_TRANSIT,
  ORDER_DELIVERY_STATUS.OUT_FOR_DELIVERY,
  ORDER_DELIVERY_STATUS.ATTEMPTED_DELIVERY,
  ORDER_DELIVERY_STATUS.DELIVERED,
  ORDER_DELIVERY_STATUS.DELAYED,
  ORDER_DELIVERY_STATUS.EXCEPTION,
  ORDER_DELIVERY_STATUS.RETURNING,
  ORDER_DELIVERY_STATUS.RETURNED,
  ORDER_DELIVERY_STATUS.CANCELLED,
]

// '' is ship_date, the API default
export const SHIPPING_DATE_FIELDS = [
  { value: '', label: 'ship-date' },
  { value: 'inducted_at', label: 'induction-date' },
  { value: 'delivered_at', label: 'delivery-date' },
]

export const INITIAL_EXPORT_SHIPMENTS = {
  client_id: '',
  date_from: '',
  date_to: '',
}
